import React from 'react';
import { Divider, List, ListItem, Box, Typography } from '@mui/material';

export default function PasswordRequirements({ props }) {
  return (
    <Box {...props}>
      <Divider sx={{ marginBottom: 0.5 }} />

      <Typography variant="h6" sx={{ fontSize: 10, fontWeight: 'bold' }}>
        Password Requirements
      </Typography>

      <Typography variant="h6" sx={{ fontSize: 10 }}>
        Min 8 characters and must consist of at least:
      </Typography>

      <List
        sx={{
          listStyleType: 'disc',
          paddingLeft: 2,
          paddingY: 0,
          lineHeight: 1,
        }}
      >
        <ListItem sx={{ display: 'list-item', padding: 0 }}>
          <Typography variant="h6" sx={{ fontSize: 10, lineHeight: 1 }}>
            One uppercase letter
          </Typography>
        </ListItem>

        <ListItem sx={{ display: 'list-item', padding: 0 }}>
          <Typography variant="h6" sx={{ fontSize: 10, lineHeight: 1 }}>
            One lowercase letter
          </Typography>
        </ListItem>

        <ListItem sx={{ display: 'list-item', padding: 0 }}>
          <Typography variant="h6" sx={{ fontSize: 10, lineHeight: 1 }}>
            One number
          </Typography>
        </ListItem>

        <ListItem sx={{ display: 'list-item', padding: 0 }}>
          <Typography variant="h6" sx={{ fontSize: 10, lineHeight: 1 }}>
            One symbol
          </Typography>
        </ListItem>
      </List>
    </Box>
  );
}
